module.exports = __webpack_public_path__ + "static/RootSans-6Italic-13355b9ae90adfb92d0ff3a0d9b7d0d6.woff";